import React from 'react';
import './JobsRedesign.css';

import jobsImage from '../../../images/jobsImage.png';

const openRoles = [
  {
    title: 'AI Engineer',
    team: 'Machine Learning',
    location: 'Remote',
    type: 'Full-time',
    summary:
      'Build and deploy AI features that improve website generation, editing assistance, and customer workflow automation.',
    skills: ['Python', 'LLMs', 'Model Serving', 'Prompt Engineering'],
  },
  {
    title: 'Frontend Developer',
    team: 'Product Engineering',
    location: 'Remote',
    type: 'Full-time',
    summary:
      'Create polished, high-performance web experiences in the editor and customer dashboard with strong UX attention.',
    skills: ['React', 'JavaScript', 'Accessibility', 'Design Systems'],
  },
  {
    title: 'Backend Developer',
    team: 'Platform Engineering',
    location: 'Remote',
    type: 'Full-time',
    summary:
      'Design and maintain reliable APIs, service integrations, and data workflows powering domains, hosting, and account systems.',
    skills: ['Node.js', 'APIs', 'Databases', 'Cloud Services'],
  },
];

const JobsContent = ({ history }) => {
  const onStartBuilding = () => {
    if (history && history.push) {
      history.push('/signup');
      return;
    }
    window.location.href = '/signup';
  };

  return (
    <div className="jobs-redesign">
      <section className="jobs-hero">
        <div className="jobs-wrap">
          <p className="jobs-eyebrow">Careers</p>
          <h1>Jobs at EditPage</h1>
          <p>
            We are building practical tools that help people launch websites faster.
            Join us if you care about product quality, speed, and meaningful impact.
          </p>
          <button type="button" onClick={onStartBuilding}>Start Building</button>
        </div>
      </section>

      <section className="jobs-main">
        <div className="jobs-wrap">
          <article className="jobs-story-card">
            <div className="jobs-story-copy">
              <h2>Why work with us</h2>
              <p>
                At EditPage, we value ownership, clear communication, and thoughtful execution.
                We support a collaborative environment where ideas are heard and strong work is recognized.
              </p>
              <p>
                Our team is focused on building products people actually use and enjoy,
                while creating room for personal and professional growth.
              </p>
            </div>
            <div className="jobs-story-media">
              <img src={jobsImage} alt="Working at EditPage" />
            </div>
          </article>

          <article className="jobs-openings">
            <div className="jobs-openings-head">
              <h2>Current openings</h2>
              <p>We are actively hiring for these roles.</p>
            </div>

            <div className="jobs-role-grid">
              {openRoles.map((role) => (
                <div className="jobs-role-card" key={role.title}>
                  <div className="jobs-role-meta">
                    <span>{role.team}</span>
                    <span>{role.location}</span>
                    <span>{role.type}</span>
                  </div>
                  <h3>{role.title}</h3>
                  <p>{role.summary}</p>
                  <div className="jobs-role-tags">
                    {role.skills.map((skill) => (
                      <span key={`${role.title}-${skill}`}>{skill}</span>
                    ))}
                  </div>
                  <a href="/contact">Apply via Contact -&gt;</a>
                </div>
              ))}
            </div>
          </article>
        </div>
      </section>
    </div>
  );
};

export default JobsContent;
